

// tabs array 
const tabs = [
    {
        "assingto": "submiter",
        "sections": [
            {
                "formFields": [
                    {
                        "id": 1,
                        "displayName": "Names Of Guests",
                        "order": 1,
                        "inputText": null,
                        "type": "Text",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },
                    {
                        "id": 2,
                        "displayName": "Arrival Date",
                        "order": 2,
                        "inputText": null,
                        "type": "date",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },
                    {
                        "id": 3,
                        "displayName": "Departure Date",
                        "order": 3,
                        "inputText": null,
                        "type": "date",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },
                    {
                        "id": 4,
                        "displayName": "No. of rooms",
                        "order": 4,
                        "inputText": null,
                        "type": "Number",
                        "modatory": false,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },
                    {
                        "id": 5,
                        "displayName": "Room Type",
                        "order": 5,
                        "inputText": null,
                        "type": "dropdown",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": [
                            {
                                "text": "Deluxe Lake View King",
                                "value": "1"
                            },
                            {
                                "text": "Deluxe Lake View Twin",
                                "value": "2"
                            },
                            {
                                "text": "Deluxe Ocean View King",
                                "value": "3"
                            },
                            {
                                "text": "Deluxe Ocean View Twin",
                                "value": "4"
                            },
                            {
                                "text": "Premier Ocean View King",
                                "value": "5"
                            },
                            {
                                "text": "Premier Balcony Room King",
                                "value": "6"
                            },
                            {
                                "text": "Horizon Club Lake View King",
                                "value": "7"
                            },
                            {
                                "text": "Horizon Club Lake View Twin",
                                "value": "8"
                            },
                            {
                                "text": "Horizon Club Ocean View King",
                                "value": "9"
                            },
                            {
                                "text": "Horizon Club Ocean View Twin",
                                "value": "10"
                            },
                            {
                                "text": "Executive Suites King",
                                "value": "11"
                            },
                            {
                                "text": "Executive Suites Twin",
                                "value": "12"
                            },
                            {
                                "text": "Specialty Suites",
                                "value": "13"
                            },
                            {
                                "text": "Shangri-La Suite",
                                "value": "14"
                            },
                            {
                                "text": "One Bedroom Apartments",
                                "value": "15"
                            },
                            {
                                "text": "Two Bedroom Apartments",
                                "value": "16"
                            }
                        ],
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },
                    {
                        "id": 6,
                        "displayName": "Company",
                        "order": 6,
                        "inputText": null,
                        "type": "Text",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },
                    {
                        "id": 7,
                        "displayName": "Purpose of Visit",
                        "order": 7,
                        "inputText": null,
                        "type": "Text",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },

                    {
                        "id": 25,
                        "displayName": "Purpose of Room",
                        "order": 25,
                        "inputText": null,
                        "type": "dropdown",
                        "modatory": true,
                        isChecked:false,
                        "options": [
                            {
                                "text": "Event-related Room",
                                "value": "Event-related Room"
                            },
                            {
                                "text": "Other",
                                "value": "Other"
                            },
                        ],
                        textTargetValue: "Other",
                        "isTextAvailable": true,
                        "textValue": {
                            "id": 26,
                            "inputText": null,
                            "modatory": true
                        }

                    },

                ],
                "columns": 3,
                "title": "Guests Details"
            }
        ],
        "title": null
    },
    {
        "assingto": null,
        "sections": [
            {
                "formFields": [
                    {
                        "id": 8,
                        "displayName": "Breakfast",
                        "order": 8,
                        "inputText": null,
                        "type": "checkbox",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },
                    {
                        "id": 9,
                        "displayName": "Half Board",
                        "order": 9,
                        "inputText": null,
                        "type": "checkbox",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },
                    {
                        "id": 10,
                        "displayName": "Full Board",
                        "order": 10,
                        "inputText": null,
                        "type": "checkbox",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },
                    {
                        "id": 11,
                        "displayName": "Others",
                        "order": 11,
                        "inputText": null,
                        "type": "checkbox",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": true,
                        "textValue": {
                            "id": 25,
                            "inputText": null
                        }
                    }
                ],
                "columns": 2,
                "title": "F&B"
            },
            {
                "formFields": [
                    {
                        "id": 13,
                        "displayName": "Pick up",
                        "order": 13,
                        "inputText": null,
                        "type": "checkbox",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },
                    {
                        "id": 14,
                        "displayName": "Drop off",
                        "order": 14,
                        "inputText": null,
                        "type": "checkbox",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },
                    {
                        "id": 15,
                        "displayName": "Round Trip",
                        "order": 15,
                        "inputText": null,
                        "type": "checkbox",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },
                    {
                        "id": 16,
                        "displayName": "Others",
                        "order": 16,
                        "inputText": null,
                        "type": "checkbox",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": true,
                        "textValue": {
                            "id": 25,
                            "inputText": null
                        }
                    }
                ],
                "columns": 2,
                "title": "Transportation"
            },
            {
                "formFields": [
                    {
                        "id": 18,
                        "displayName": "CHI THE SPA treatment",
                        "order": 18,
                        "inputText": null,
                        "type": "checkbox",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    }
                ],
                "columns": 1,
                "title": "CHI THE SPA "
            },
            {
                "formFields": [
                    {
                        "id": 19,
                        "displayName": "Discount ",
                        "order": 19,
                        "inputText": null,
                        "type": "checkbox",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": true,
                        "textValue": {
                            "id": 25,
                            "inputText": null
                        }
                    },
                    {
                        "id": 20,
                        "displayName": "Laundry",
                        "order": 20,
                        "inputText": null,
                        "type": "checkbox",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },
                    {
                        "id": 21,
                        "displayName": "Pressing",
                        "order": 21,
                        "inputText": null,
                        "type": "checkbox",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    },
                    {
                        "id": 22,
                        "displayName": "Dry Cleaning",
                        "order": 22,
                        "inputText": null,
                        "type": "checkbox",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    }
                ],
                "columns": 2,
                "title": "Laundry"
            },
            {
                "formFields": [
                    {
                        "id": 24,
                        "displayName": "Remarks (Description)",
                        "order": 24,
                        "inputText": null,
                        "type": "TextArea",
                        "modatory": true,
                        "isChecked": false,
                        "attachmentData": null,
                        "fileList": null,
                        "options": null,
                        "selectedValue": null,
                        "isTextAvailable": false,
                        "textValue": null
                    }
                ],
                "columns": 1,
                "title": "Remaks/Description"
            }
        ],
        "title": "Inclusions"
    }
];

const eventComplementaryFormRequest = {
    data:{
    "id": 19,
    "name": "Events - Complimentary Room Request",
    "createdOn": "2021-02-16T06:48:29.59+00:00",
    "modifiedOn": "2021-02-16T06:48:29.59+00:00",
    "tab": "[{\"assingto\":\"submiter\",\"sections\":[{\"formFields\":[{\"id\":1,\"displayName\":\"Names Of Guests\",\"order\":1,\"inputText\":null,\"type\":\"Text\",\"modatory\":true},{\"id\":2,\"displayName\":\"Arrival Date\",\"order\":2,\"inputText\":null,\"type\":\"date\",\"modatory\":true},{\"id\":3,\"displayName\":\"Departure Date\",\"order\":3,\"inputText\":null,\"type\":\"date\",\"modatory\":true},{\"id\":4,\"displayName\":\"No. of rooms\",\"order\":4,\"inputText\":null,\"type\":\"Number\",\"modatory\":false},{\"id\":5,\"displayName\":\"Room Type\",\"order\":5,\"inputText\":null,\"type\":\"dropdown\",\"modatory\":true,\"options\":[]},{\"id\":6,\"displayName\":\"Company\",\"order\":6,\"inputText\":null,\"type\":\"Text\",\"modatory\":true},{\"id\":7,\"displayName\":\"Purpose of Visit\",\"order\":7,\"inputText\":null,\"type\":\"Text\",\"modatory\":true},{\"id\":25,\"displayName\":\"Purpose of Room\",\"order\":25,\"inputText\":null,\"type\":\"dropdown\", \"modatory\": true,\"options\":[{\"text\":\"event-related-room\", \"value\":\"event-related-room\"},{\"text\":\"other\",\"value\":\"other\"}],\"textTargetValue\":\"Other\",\"isTextAvailable\":true,\"textValue\":{\"id\":26,\"inputText\":null,\"modatory\":true}}],\"columns\":3,\"title\":\"Guests Details\"}]},{\"title\":\"Inclusions\",\"sections\":[{\"columns\":2,\"title\":\"F&B\",\"formFields\":[{\"id\":8,\"displayName\":\"Breakfast\",\"order\":8,\"inputText\":null,\"type\":\"checkbox\",\"modatory\":true,\"IsChecked\":false,\"isTextAvailable\":false,\"textValue\":null},{\"id\":9,\"displayName\":\"Half Board\",\"order\":9,\"inputText\":null,\"type\":\"checkbox\",\"modatory\":true,\"IsChecked\":false,\"isTextAvailable\":false,\"textValue\":null},{\"id\":10,\"displayName\":\"Full Board\",\"order\":10,\"inputText\":null,\"type\":\"checkbox\",\"modatory\":true,\"IsChecked\":false,\"isTextAvailable\":false,\"textValue\":null},{\"id\":11,\"displayName\":\"Others\",\"order\":11,\"inputText\":null,\"type\":\"checkbox\",\"modatory\":true,\"IsChecked\":false,\"isTextAvailable\":true,\"textValue\":{\"id\":25,\"inputText\":null}}]},{\"columns\":2,\"title\":\"Transportation\",\"formFields\":[{\"id\":13,\"displayName\":\"Pick up\",\"order\":13,\"inputText\":null,\"type\":\"checkbox\",\"modatory\":true,\"IsChecked\":false,\"isTextAvailable\":false,\"textValue\":null},{\"id\":14,\"displayName\":\"Drop off\",\"order\":14,\"inputText\":null,\"type\":\"checkbox\",\"modatory\":true,\"IsChecked\":false,\"isTextAvailable\":false,\"textValue\":null},{\"id\":15,\"displayName\":\"Round Trip\",\"order\":15,\"inputText\":null,\"type\":\"checkbox\",\"modatory\":true,\"IsChecked\":false,\"isTextAvailable\":false,\"textValue\":null},{\"id\":16,\"displayName\":\"Others\",\"order\":16,\"inputText\":null,\"type\":\"checkbox\",\"modatory\":true,\"IsChecked\":false,\"isTextAvailable\":true,\"textValue\":{\"id\":25,\"inputText\":null}}]},{\"columns\":1,\"title\":\"CHI THE SPA \",\"formFields\":[{\"id\":18,\"displayName\":\"CHI THE SPA treatment\",\"order\":18,\"inputText\":null,\"type\":\"checkbox\",\"modatory\":true,\"IsChecked\":false,\"isTextAvailable\":false,\"textValue\":null}]},{\"columns\":2,\"title\":\"Laundry\",\"formFields\":[{\"id\":19,\"displayName\":\"Discount \",\"order\":19,\"inputText\":null,\"type\":\"checkbox\",\"modatory\":true,\"IsChecked\":false,\"isTextAvailable\":true,\"textValue\":{\"id\":25,\"inputText\":null}},{\"id\":20,\"displayName\":\"Laundry\",\"order\":20,\"inputText\":null,\"type\":\"checkbox\",\"modatory\":true,\"IsChecked\":false,\"isTextAvailable\":false,\"textValue\":null},{\"id\":21,\"displayName\":\"Pressing\",\"order\":21,\"inputText\":null,\"type\":\"checkbox\",\"modatory\":true,\"IsChecked\":false,\"isTextAvailable\":false,\"textValue\":null},{\"id\":22,\"displayName\":\"Dry Cleaning\",\"order\":22,\"inputText\":null,\"type\":\"checkbox\",\"modatory\":true,\"IsChecked\":false,\"isTextAvailable\":false,\"textValue\":null}]},{\"columns\":1,\"title\":\"Remaks\\/Description\",\"formFields\":[{\"id\":24,\"displayName\":\"Remarks (Description)\",\"order\":24,\"inputText\":null,\"type\":\"TextArea\",\"modatory\":true}]}]}]",
    "tabs":tabs,
    "createdUserId": null,
    "createdUser": null,
    "modifiedUserId": null,
    "modifiedUser": null,
    "requestProcessLevels": [],
    "requests": []
}};

export default eventComplementaryFormRequest;